import { Box } from "@material-ui/core";
import { ReactNode } from "react";
import { ViewAssumptions } from "./ViewAssumptions";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

export const GraphSectionLayout = ({
  leftContent,
  rightContent,
  title,
  description
}: {
  leftContent: ReactNode;
  rightContent: ReactNode;
  title: string;
  description: string;
}) => {
  const { isMoreThanMd, isMoreThanSm } = useBreakpoint();
  return (
    <Box maxWidth={"996px"} px={isMoreThanMd ? 0 : "21px"} margin={"0 auto"}>
      <Box display={"flex"} flexDirection={isMoreThanMd ? "row" : "column"}>
        <Box width={isMoreThanMd ? "43%" : "100%"} pr={"20px"}>
          <Box
            fontSize={isMoreThanSm ? "20px" : "16px"}
            fontWeight={500}
            lineHeight={isMoreThanSm ? 1.2 : 1.5}
            color={"#4b5462"}
            textAlign={isMoreThanMd ? "inherit" : "center"}
          >
            {title}
          </Box>
          <Box
            mt={isMoreThanSm ? "24px" : "20px"}
            fontSize={isMoreThanSm ? "14px" : "12px"}
            fontWeight={400}
            lineHeight={1.71}
            letterSpacing={"0.32px"}
            color={"#4b5462"}
            textAlign={isMoreThanMd ? "inherit" : "center"}
          >
            {description}
          </Box>
          {isMoreThanMd ? leftContent : null}
          {isMoreThanMd && <ViewAssumptions />}
        </Box>
        <Box width={isMoreThanMd ? "57%" : "100%"} mt={isMoreThanMd ? 0 : "30px"} pl={isMoreThanMd ? "48px" : 0}>
          {rightContent}
        </Box>
        {!isMoreThanMd ? leftContent : null}
        {!isMoreThanMd && <ViewAssumptions />}
      </Box>
    </Box>
  );
};
